"use client"
import { MenuItem } from "@mantine/core"
import { IconLogout } from "@tabler/icons-react"
import { showNotification } from "@/lib/notifications"

export function MenuItemLogOutButton() {
  return (
    <MenuItem
      color="red"
      leftSection={<IconLogout size={16} data-testid="menu-item-log-out-btn" />}
      onClick={async () => {
        try {
          window.location.replace("/api/auth/logout")
        } catch (err) {
          showNotification({
            type: "error",
            title: "Error while logging out",
            message: (err as any)?.message ?? "Try again in a few seconds or reach your administrator for help.",
          })
        }
      }}
    >
      Log Out
    </MenuItem>
  )
}
